<app-nine-sliced-sprite
  src="https://prod.docsiteassets.roblox.com/assets/ui/9-slice/9-Slice-Concept-Diagram.png"
  [x]="[0.322815534, 0.6759708738]"
  [y]="[0.3807471264, 0.6149425287]"
  width="60px"
  style="display: inline-block; width: 800px; height: 400px"
/>
<app-nine-sliced-sprite
  src="https://prod.docsiteassets.roblox.com/assets/ui/9-slice/9-Slice-Concept-Diagram.png"
  [x]="[0.322815534, 0.6759708738]"
  [y]="[0.3807471264, 0.6149425287]"
  width="60px"
  style="display: inline-block; width: 400px; height: 400px"
/>
<app-nine-sliced-sprite
  src="https://prod.docsiteassets.roblox.com/assets/ui/9-slice/9-Slice-Concept-Diagram.png"
  [x]="[0.322815534, 0.6759708738]"
  [y]="[0.3807471264, 0.6149425287]"
  width="60px"
  style="display: inline-block; width: 200px; height: 400px"
/>
<app-nine-sliced-sprite
  src="https://prod.docsiteassets.roblox.com/assets/ui/9-slice/9-Slice-Concept-Diagram.png"
  [x]="[0.322815534, 0.6759708738]"
  [y]="[0.3807471264, 0.6149425287]"
  width="60px"
  style="display: inline-block; width: 100%; height: 800px"
/>
<app-nine-sliced-sprite
  src="https://prod.docsiteassets.roblox.com/assets/ui/9-slice/9-Slice-Concept-Diagram.png"
  [x]="[0.322815534, 0.6759708738]"
  [y]="[0.3807471264, 0.6149425287]"
  width="60px"
  style="display: inline-block; width: 400px; height: 200px"
/>
